import React,{ useState} from "react"
import {Modal} from "reactstrap"
import "../../assets/scss/manual/manual.scss";
import toast from 'react-hot-toast';
import axios from "axios";
import AppConfig from "constants/config";

const RestoreUser = (prop) => {
    const {restoreUser, toggleRestore, setRestoreUser, user, getArchievData, getAccountsData, setSelectedUser} = prop;
    const [loading, setLoading] = useState(false);

    const restoreAccount = async() => {
        setLoading(true);
        try {
            const {data} = await axios.post(`${AppConfig.baseUrl}/customer/restore`, {id: user.customer_id._id},{
              headers: { token: localStorage.getItem("token") }
            });
            if(!data.error){
                toast.success('Account restored successfully');
                getAccountsData({})
                getArchievData({})
                handleClosePopup()
            }
            else{
                throw new Error(data.title);
            }
        } catch (error) {
            toast.error(error.message || 'Something went wrong');
        }
        setLoading(false);
    }

    const handleClosePopup = () => {
        setRestoreUser(false);
        setSelectedUser({})
    }

    return (
        <Modal
            isOpen={restoreUser}
            toggle={() => {
                toggleRestore();
            }}
            centered
        >
            <div className="modal-header">
                <h5 className="modal-title mt-0">Restore Account</h5>
                <button
                    type="button"
                    onClick={() => {
                        handleClosePopup()
                    }}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <form>
                    <div className="mb-3">
                        Are you sure you want to restore this account ?
                    </div>
                    <div className="modal-footer mt-0">
                        <button
                            type="button"
                            className="btn bg-theme-color"
                            onClick={() =>
                                handleClosePopup()
                            }
                            disabled={loading}
                        >
                            {
                                loading && <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> 
                            }
                            No
                        </button>
                        <button type="button" className="btn bg-theme-color" onClick={restoreAccount} disabled={loading}>
                            {
                                loading && <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> 
                            }
                            Yes
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    )
}

export default RestoreUser